import React from 'react';

function ButtonMainComponent(props) {
    return (
        <button
            className={props.styleCSS}
            title={props.propTitle}
            aria-label={props.propTitle}
            disabled={props.disableProp}
            onClick={props.onClickEvent}
            onMouseDown={props.onMouseDownEvent}
            id={props.idName}
            style={props.style}>
            {props.lblButton}
        </button>
    );
}
export default ButtonMainComponent;
